'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPhone = void 0;
var $ = require("jquery");
var SmartPhone = /** @class */ (function () {
    function SmartPhone() {
        var _this = this;
        this.SPWIDTH = 1024;
        $(window).on('load', function () {
            _this.changePageTop();
        });
        $(window).on('resize', function () {
            _this.changePageTop();
        });
    }
    SmartPhone.prototype.changePageTop = function () {
        var browserWidth = $(window).width();
        var headerHeight = 0;
        if (this.SPWIDTH >= browserWidth) {
            headerHeight = $('.paramSpHeader').height();
        }
        $('#bulletPageTop').css('padding-top', headerHeight);
    };
    return SmartPhone;
}());
exports.SmartPhone = SmartPhone;
exports.default = SmartPhone;
